import React from 'react'
import { Space, Modal, Button, Tooltip, message as $message } from 'antd'
import { createAPI } from '@/utils/modal'

import styles from './index.less'
import copy from 'copy-to-clipboard'
import OlineSoidAfterSaleCountLink, {
    handelClickOlineSoidAfterSaleCountInOrder
} from '@/modules/afterSale/components/OlineSoidAfterSaleCountLink'

import ActionBtn from '@/components/TableWidgets/ActionBtn'
import CustomIcon from '@/components/CustomIcon'
import CustomOperationIcon from '@/modules/globals/components/CustomOperationIcon'

import classNames from 'classnames'

const DataSourceText = ({ isCanClick, onClick, dataSource }) => {
    if (isCanClick) {
        return (
            <ActionBtn textWrap underline onClick={() => onClick(dataSource)}>
                {dataSource}
            </ActionBtn>
        )
    }
    return dataSource
}

export default ({
    dataSource,
    color,
    type = '',
    hideDataSource = false,
    needBg = false,
    popTitle,
    beforeCopyApi,
    className,
    record,
    afterSaleCountMap,
    isCanClick,
    onClick = () => {},
    onBeforeCopy,
    iconType = 'icon-fuzhi',
    iconText
}) => {
    if (!dataSource) {
        return null
    }

    const handleClick = async text => {
        const flag = localStorage.getItem('seeSpac-0914')
        let copyInfo = text
        let successTips = '复制成功'
        if (beforeCopyApi && typeof beforeCopyApi === 'function') {
            try {
                const { success, data, message } = await beforeCopyApi()
                if (success) {
                    copyInfo = data
                } else {
                    $message.error(message)
                    return
                }
            } catch (error) {
                console.error('catchError', error)
                return
            }
        }
        if (onBeforeCopy && typeof onBeforeCopy === 'function') {
            const { data, message } = await onBeforeCopy()
            copyInfo = data
            successTips = message
        }
        if (copyInfo === false) {
            return
        }
        copy(copyInfo, {
            format: 'text/plain',
            onCopy: () => {
                if (type === 'modal' && !flag) {
                    createAPI(TipModal, {})
                } else {
                    $message.success(successTips)
                }
            }
        })
    }

    // eslint-disable-next-line react/no-unstable-nested-components
    const TipModal = ({ visible, onCancel }) => {
        return (
            <Modal
                title="提示"
                closable={false}
                footer={
                    <Button
                        onClick={() => {
                            localStorage.setItem('seeSpac-0914', true)
                            onCancel()
                        }}
                    >
                        知道了
                    </Button>
                }
                maskClosable={false}
                bodyStyle={{ padding: '0 10px' }}
                visible={visible}
                // onCancel={onCancel}
            >
                <div className={styles.modal}>
                    <CustomIcon style={{ color: '#22B001', fontSize: '30px' }} type="icon-icon-kepiliangshangjia" />
                    <p>复制成功</p>
                    <p>1、供销+/自营订单的订单号=商家自己的内部订单号</p>
                    <p>2、分销+/分销+供销+的订单号=供应商的线上订单号</p>
                </div>
            </Modal>
        )
    }

    if (Array.isArray(dataSource)) {
        return (
            <Space direction="vertical" size={0}>
                {dataSource.map(i => {
                    const count = afterSaleCountMap?.[`${i}-${record?.channelCoId || 0}`]
                    return (
                        <div key={i}>
                            <span className={styles.container}>
                                <DataSourceText isCanClick={isCanClick} onClick={onClick} dataSource={i} />
                                <a
                                    data-log-text="复制"
                                    style={{
                                        color: color ? color : window.MASTER_PROJECT_CONFIG.defaultSettings.primaryColor
                                    }}
                                >
                                    <CustomIcon
                                        onClick={() => handleClick(i)}
                                        className={styles.icon}
                                        type={iconType}
                                    />
                                </a>
                            </span>
                            {count > 0 && record && (
                                <OlineSoidAfterSaleCountLink
                                    count={count}
                                    handelClick={() => {
                                        handelClickOlineSoidAfterSaleCountInOrder({
                                            orderType: record.orderType,
                                            soIdList: i
                                        })
                                    }}
                                />
                            )}
                        </div>
                    )
                })}
            </Space>
        )
    }

    return (
        <span className={classNames(className, { [styles.container]: !hideDataSource })}>
            {hideDataSource ? null : (
                <DataSourceText isCanClick={isCanClick} onClick={onClick} dataSource={dataSource} />
            )}
            {popTitle ? (
                <Tooltip title={popTitle}>
                    <a
                        data-log-text="复制"
                        onClick={() => handleClick(dataSource)}
                        style={{ color: color ? color : window.MASTER_PROJECT_CONFIG.defaultSettings.primaryColor }}
                    >
                        <CustomIcon className={styles.icon} type={iconType} />
                        {iconText ? <span>&nbsp;{iconText}</span> : null}
                    </a>
                </Tooltip>
            ) : (
                <a
                    data-log-text="复制"
                    onClick={() => handleClick(dataSource)}
                    style={{ color: color ? color : window.MASTER_PROJECT_CONFIG.defaultSettings.primaryColor }}
                >
                    {needBg ? (
                        <CustomOperationIcon className={styles.icon} type={iconType} />
                    ) : (
                        <CustomIcon className={styles.icon} type={iconType} />
                    )}
                    {iconText ? <span>&nbsp;{iconText}</span> : null}
                </a>
            )}
        </span>
    )
}
